import React from 'react';
import logo from '../assets/logo.svg';
import backArrow from '../assets/back_arrow.png';
import { useHistory } from 'react-router-dom';
import ArrowBack from '@material-ui/icons/ArrowBack';

const Header = ({ home }) => {
  const history = useHistory();
  if (home) {
    return (
      <header className="bg-primary d-flex flex-columns mb-5">
        <div className="d-flex align-items-center ml-3">
          <img alt="logo-bonte" className="logo" src={logo} />
        </div>
      </header>
    );
  } else {
    return (
      <header className="bg-primary d-flex mb-5 justify-content-center">
        <div
          className="d-flex justify-content-around align-items-center ml-5 back"
          onClick={() => history.goBack()}
        >
          <ArrowBack fontSize="small" style={{ marginRight: '10px' }} />
          <span>Volver</span>
        </div>

        <div
          className="d-flex align-items-center ml-3"
          onClick={() => history.push('/')}
        >
          <img alt="logo" className="logo" src={logo} />
        </div>
      </header>
    );
  }
};

export default Header;
